import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileListAddFill.tsx
const IconFileListAddFill = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 32 32",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M6.667 29.333h18.666a4 4 0 0 0 4-4V20H24V4c0-.736-.597-1.333-1.333-1.333H4c-.736 0-1.333.597-1.333 1.333v21.333a4 4 0 0 0 4 4m17.333-4v-2.666h2.667v2.666a1.333 1.333 0 1 1-2.667 0M8 12h4V8h2.667v4h4v2.667h-4v4H12v-4H8z"
	})]
});
var IconFileListAddFill_default = forwardRef(IconFileListAddFill);
//#endregion
export { IconFileListAddFill_default as default };
